import { SplitMulti, TrimAny } from "../../libs/util/util_string";
import { SpwkUtilV3 } from "./SpwkUtilV3";
import { UniForm } from "./UniForm";
import { InputToken, UniOption } from "./UniOption";
import { UniQuestion } from "./UniQuestion";

export class SpwkUtil {
  static KIND_空白 = "";
  static KIND_多選 = "多選";
  static KIND_單選 = "單選";
  static KIND_非選 = "非選";
  static KIND_標題 = "標題";
  static KIND_圖片 = "圖片";
  static KIND_自訂 = "自訂";


  static CHAPTER_基本資料 = "基本資料";
  static CHAPTER_檢查時期 = "檢查時期";
  static CHAPTER_作業經歷 = "作業經歷";

  static CHAPTER_既往病史 = "既往病史";
  static CHAPTER_既往病史_噪音作業 = "既往病史(噪音作業)";

  static CHAPTER_生活習慣 = "生活習慣";

  static CHAPTER_自覺症狀 = "自覺症狀";
  static CHAPTER_自覺症狀_噪音作業 = "自覺症狀(噪音作業)";

  static CHAPTER_疲勞狀況 = "疲勞狀況";

  static CHAPTER_環境監測 = "環境監測";

  static A01_func_guid = "07A3AEE0";
  static A98_func_guid = "1BF3FD21";
  static B01_func_guid = "57D4C14F";
  static B02_func_guid = "AD72295B";
  static B03_func_guid = "80B67D09";
  static B04_func_guid = "4A1F2C21";
  static B05_func_guid = "27101376";
  static B06_func_guid = "DCFF7054";
  static B07_func_guid = "7291F06C";
  static B08_func_guid = "BD874765";
  static B09_func_guid = "A8AD9A0A";
  static B10_func_guid = "F4443D24";
  static B11_func_guid = "BFD6C94E";
  static B12_func_guid = "38805CEB";
  static B13_func_guid = "4D37E3B2";
  static B14_func_guid = "EB564E77";
  static B15_func_guid = "109A99AC";
  static B16_func_guid = "A7F55757";
  static B17_func_guid = "B3C3EFBC";
  static B18_func_guid = "37B13790";
  static B19_func_guid = "EF3061D2";
  static B20_func_guid = "406003C7";
  static B21_func_guid = "ED5A7F83";
  static B22_func_guid = "A36E1904";
  static B23_func_guid = "57B34A34";
  static B24_func_guid = "F27C54DC";
  static B25_func_guid = "BFABD7F9";
  static B26_func_guid = "20004CA2";
  static B27_func_guid = "5E7B2B26";
  static B28_func_guid = "DD782004";
  static B29_func_guid = "A7284B0F";
  static B30_func_guid = "81E866C9";
  static B31_func_guid = "1D08D4BC";

  //切換到UniQuest資料庫後,func_guid 有變
  static CODE_A01 = "A01";
  static CODE_A98 = "A98";
  static CODE_B02 = "B02";



  static GetMergeQuestions(
    chapter: string,
    _UniFormList: UniForm[] | undefined
  ): UniQuestion[] {
    let questions: UniQuestion[] = [];

    // TODO 合併 相同 code 的問題與選項
    if (_UniFormList != null) {
      for (const form of _UniFormList) {
        const q_list = form.AllQuestions?.filter((q) => q.chapter === chapter);

        if (q_list != null) {
          questions = [...questions, ...q_list];
        }
      }
    }

    return questions;
  }

  static GetChapterQuestionsV3(chapter: string, _SpwkBaseForm: UniForm, _UniFormList: UniForm[]) {
    // 目前最後一個參數似乎用不到了
    return SpwkUtil.GetChapterQuestions(chapter, _SpwkBaseForm, _UniFormList, _UniFormList.map(x => x.func_guid));
  }

  /**
   * (注意! 此方法可能在多處使用，修改時要小心不要互相影響)
   * 給定章節，基礎問題集，一堆要合併的問卷列表(樹狀結構)，指定要合併的特作GUID
   * 最後回傳合併好的題目
   * 診列只放單一問卷時，相當於開啟單獨的特作問卷
   **/
  static GetChapterQuestions(
    chapter: string,
    _SpwkBaseForm: UniForm,
    _UniFormList: UniForm[],
    func_guid_list: string[]
  ): UniQuestion[] {
    /* 總是先備好各章節的基礎題目(至少有標題) */
    let base_questions = _SpwkBaseForm?.AllQuestions?.filter(
      (q) => q.chapter === chapter
    );

    if (base_questions == null) {
      alert("應該要有 base_questions !!!");
      throw new Error("應該要有 base_questions !!!");
    }

    // 選取的特作代碼列表
    const spwk_list = _UniFormList.map((form) => form.form_code);
    /* 基礎項目在不同特作會顯示或隱藏 如: A98夜間工作相關的題目 只有在 func_guid_list 包含 A98 時才要顯示 */
    base_questions = base_questions?.filter((x) =>
      x.HasFunc2(spwk_list == null ? [] : spwk_list)
    );

    /* 接著篩選此章節的題目 */
    let chapter_questions: UniQuestion[] = [];
    // console.log("chapter: " + chapter);

    if (_UniFormList != null) {
      for (const form of _UniFormList) {
        const q_list = form.AllQuestions?.filter((q) => q.chapter === chapter);

        if (q_list != null) {
          chapter_questions = [...chapter_questions, ...q_list];
        }
      }
    }

    /* 既往病史 與 自覺症狀 預設要合併 */
    if (
      chapter === this.CHAPTER_既往病史 ||
      chapter === this.CHAPTER_自覺症狀
    ) {
      // TODO 合併 相同 code 的問題與選項
    }

    return [...base_questions, ...chapter_questions];
  }

  //#region react-hook-form 儲存對應路徑
  static get_Question_RhfName(chapter: string, question_code: string): string {
    return chapter + "." + question_code;
  }

  /** 多選(CheckBox)用的 RhfName */
  static get_Option_RhfName(
    chapter: string,
    question_code: string,
    option_code: string
  ) {
    return (
      SpwkUtil.get_Question_RhfName(chapter, question_code) + "." + option_code
    );
  }

  static get_Input_RhfName(
    chapter: string,
    question_code: string,
    option_code: string,
    input_code: string
  ) {
    return (
      SpwkUtil.get_Question_RhfName(chapter, question_code) +
      "●" +
      option_code +
      "●input_" +
      input_code
    );
  }
  //#endregion

  /**
   * 問題的多國語言，目前先這樣處理
   * - 目前這樣會導致每次要使用都要撈出各語言的文字，導致速度較慢
   */
  static __getQuestionTitleByLang(
    data: UniQuestion,
    lang: Lang
  ): string | null {
    let re: string | null = null;

    if (lang === "CHI") {
      re = data.question_title;
    } else if (lang === "ENG") {
      re = data.title_eng;
    } else if (lang === "IND") {
      re = data.title_ind;
    } else if (lang === "THA") {
      re = data.title_tha;
    } else if (lang === "TGL") {
      re = data.title_tgl;
    } else if (lang === "VIE") {
      re = data.title_vie;
    } else if (lang === "RHF_NAME") {
      re = data.get_Question_RhfName();
    } else if (lang === "CODE") {
      re = data.question_code;
    } else if (lang === "HIS") {
      // re = data.ch_his_code + "." + data.q_his_code;
      re = data.ch_his_code + "." + data.q_his_code;

      // re = "WWW";

      // if(data.kind === SpwkUtil.KIND_單選){
      //   re = 'HIS 單選';
      // } else{
      //   re = '---';
      // }
    } else if (lang === "GOV") {
      re = data.q_gov_code;

    } else if (lang === "") {
      re = null;
    } else {
      alert("沒有這個語言" + lang);
    }

    return re;
  }

  /**
   * 問題的多國語言，目前先這樣處理
   * - 目前這樣會導致每次要使用都要撈出各語言的文字，導致速度較慢
   */
  static __getOptionTitleByLang(data: UniOption, lang: Lang): string | null {
    let re: string | null = null;

    if (lang === "CHI") {
      re = data.option_title;
    } else if (lang === "ENG") {
      re = data.title_eng;
    } else if (lang === "IND") {
      re = data.title_ind;
    } else if (lang === "THA") {
      re = data.title_tha;
    } else if (lang === "TGL") {
      re = data.title_tgl;
    } else if (lang === "VIE") {
      re = data.title_vie;
    } else if (lang === "RHF_NAME") {
      re = data.get_Option_RhfName();
    } else if (lang === "CODE") {
      re = data.option_code;
    } else if (lang === "HIS") {
      if (
        data.question_kind === SpwkUtil.KIND_多選 ||
        data.question_kind === SpwkUtil.KIND_單選
      ) {
        re = data.ch_his_code + "." + data.q_his_code + " = " + data.o_his_code;

        // re = 'HIS 多選';
      } else {
        re = "---";
      }
    } else if (lang === "GOV") {
      re = data.o_gov_code;

    } else if (lang === "") {
      re = null;
    } else {
      alert("沒有這個語言" + lang);
    }

    return re;
  }

  static 僅保留有Data中有輸入的數值(data: any): any {
    return SpwkUtil.ClearEmptyNode(SpwkUtil.ClearEmptyValue(data));
  }

  /**
   * https://stackoverflow.com/questions/42736031/remove-empty-objects-from-an-object
   * 清除空物件 {}
   */
  static ClearEmptyNode(o: any): any {
    for (var k in o) {
      if (!o[k] || typeof o[k] !== "object") {
        continue; // If null or not an object, skip to the next iteration
      }

      // The property is an object
      SpwkUtil.ClearEmptyNode(o[k]); // <-- Make a recursive call on the nested object
      if (Object.keys(o[k]).length === 0) {
        delete o[k]; // The object had no properties, so delete that property
      }
    }
    return o;
  }

  /**
   * // https://stackoverflow.com/questions/286141/remove-blank-attributes-from-an-object-in-javascript
   * 移除被視為空白數值的節點
   * 可能會剩下 {} 空物件
   */
  static ClearEmptyValue(obj: any): any {
    return Object.keys(obj)
      .filter(function (k) {
        const val = obj[k];

        // null、undefined、""、false 視為 空白數值
        return val != null && val !== "" && val !== false;
      })
      .reduce(function (acc: any, k) {
        acc[k] =
          typeof obj[k] === "object"
            ? SpwkUtil.ClearEmptyValue(obj[k])
            : obj[k];

        return acc;
      }, {});
  }

  /**
   * 產出黏在此選向上的 inputs，如果沒有，則回傳 []
   */
  static CreateInputTokens(option: UniOption, title: string | null) {
    let token_list: (string | InputToken)[] = [];
    let label_list: string[] = [];
    let input_list: InputToken[] = [];

    if (option.HasInputs() === false) {
      return { token_list, input_list, label_list };
    }

    title = title == null ? option.option_title : title;

    let tokens = SplitMulti(title, ["{_", "_}"]);

    for (let ii = 0; ii < tokens.length; ii++) {
      let token = tokens[ii];
      if (ii % 2 === 0) {
        // IsLabel
        token_list.push(token);
        label_list.push(token);
      } else if (ii % 2 === 1) {
        // IsInput
        let input_code = TrimAny(token, [" ", "{", "}", "_"]);
        let input = new InputToken(option, input_code);
        token_list.push(input);
        input_list.push(input);
      }
    }

    return { token_list, input_list, label_list };
  }
}

export type Lang =
  | "CHI"
  | "ENG"
  | "IND"
  | "THA"
  | "TGL"
  | "VIE"
  | "RHF_NAME"
  | "CODE"
  | "HIS"
  | "GOV"
  | "";

/**
 * 判斷此 Lang 是否為 Debug 用的
 * - 用來改變 input 寬度，方便看到完整的名字 DEBUG
 */
export function is_debug_lang(lang: Lang) {
  return (lang === SpwkUtilV3.LANG_CODE || lang === SpwkUtilV3.LANG_RHF_NAME || lang === SpwkUtilV3.LANG_HIS || lang === SpwkUtilV3.LANG_GOV);
}
